import { gql } from '@apollo/client';

export type CalendarEventSeason = {
  id: string;
  fullName: string;
};

const QUERY = gql`
  query CalendarEventSeasons($organizationId: Int!) {
    calendarEventSeasons(organizationId: $organizationId) {
      id
      fullName
    }
  }
`;

export default QUERY;
